export default __webpack_public_path__ + "static/media/usaid.30619e89.png";